import { makeStyles } from '@material-ui/core';

export default makeStyles({
  option: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'block',
  },
});
